module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-ksenia-kartasheva-dedf474cb0b0ed4554a5e06ad773a2b3.jpg";